<template>
  <div class="index-main-right">
    <component :is="item" v-for="(item, index) in conf" :key="index" :ref="item" class="box" />
  </div>
</template>
<script>
let components = {};
const conf = ['rightCompanyInfo', 'rightService','rightQrcode','rightNotice' ];
conf.forEach(item => (components[item] = require('./components/' + item + '.vue').default));

export default {
  components,
  data() {
    return {
      conf,
    };
  },
};
</script>

<style lang="scss" scoped>
.index-main-right {
  position: absolute;
  right: 0;
  top: 0;
  width: 453px;
  .box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 7px 0px rgba(214, 214, 214, 0.5);
    border-radius: 8px;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
